const menuConfig = [
    {
      title: "Danh sách MasterData",
      icon: "bx bx-file",
      children: [
        { path: "/site", label: "Danh sách Site", icon: "mdi mdi-sitemap" },
        { path: "/master-testcode", label: "DS Master TestCode", icon: "bx bx-code-block" },
        { path: "/master-instrument", label: "DS Master Instrument", icon: "mdi mdi-smart-card-reader-outline" },
        { path: "/erp-product", label: "Danh sách sản phẩm ERP", icon: "fab fa-waze" },
        { path: "/master-grouptest", label: "Danh sách bộ xét nghiệm", icon: "fas fa-object-group" },
        { path: "/master-instrument-type", label: "Danh sách Instrument Type", icon: "mdi mdi-instrument-triangle" },
        { path: "/master-parent-test", label: "Danh sách xét nghiệm thương mại", icon: "bx bx-book-bookmark" },
      ],
    },
    { path: "/combine-instrument", label: "Danh sách xét nghiệm máy", icon: "mdi mdi-clipboard-list" },
    { path: "/combine-result", label: "Danh sách xét nghiệm", icon: "bx bx-test-tube" },
    {
      title: "Khớp mã",
      icon: "mdi mdi-circular-saw",
      children: [
        { path: "/instrument", label: "Khớp mã Instrument", icon: "bx bx-link" },
        { path: "/map-testcode", label: "Khớp mã TestCode", icon: "bx bx-link" },
        { path: "/InstrumentSurvey", label: "Khớp mã InstrumentSurvey", icon: "bx bx-link" },
        { path: "/CategorySurvey", label: "Khớp mã CategorySurvey", icon: "bx bx-link" },
      ],
    },
    {
      title: "Thống kê",
      icon: "mdi mdi-chart-multiple",
      children: [
        { path: "/ls-statistics-number", label: "Thống kê số lượng", icon: "mdi mdi-calculator-variant-outline" },
        { path: "/ls-statistics-sale", label: "Thống kê doanh số", icon: "mdi mdi-cash-check" },
        { path: "/report", label: "Thống kê dữ liệu", icon: "bx bx-bar-chart-alt" },
        { path: "/powerbi-erp", label: "Dashboard ERP", icon: "mdi mdi-monitor-dashboard" },
        { path: "/total-statistics", label: "Thống kê dữ liệu tổng", icon: "mdi mdi-calculator-variant-outline" },
        { path: "/StatisticsEffective", label: "Thống kê hiệu quả đầu tư", icon: "mdi mdi-calculator-variant-outline" },
        { path: "/StatisticsRealSale", label: "Thống kê doanh số thực", icon: "mdi mdi-calculator-variant-outline" },
        { path: "/StatisticsSurveyResult", label: "Thống kê dữ liệu khảo sát", icon: "mdi mdi-calculator-variant-outline" },
        { path: "/StatisticsAnnualData", label: "Thống kê dữ liệu tổng hợp năm", icon: "mdi mdi-calculator-variant-outline" },
      ],
    },
    { path: "/data-hospital", label: "Dữ liệu bệnh viện", icon: "mdi mdi-instrument-triangle" },
    { path: "/sample-path-hospital", label: "Dữ liệu luồng mẫu", icon: "mdi mdi-instrument-triangle", badge: "New" },
    { path: "/AnalyzerPath", label: "Danh sách máy trên luồng", icon: "mdi mdi-instrument-triangle" },
    {
      title: "Hồ sơ báo cáo vận hành",
      icon: "mdi mdi-chart-multiple",
      badge: "New",
      children: [
        { path: "/auto-system-evaluate", label: "Dashboard đánh giá hệ tự động", icon: "mdi mdi-calculator-variant-outline" },
        { path: "/tat-machine-system", label: "Dashboard đánh giá máy", icon: "mdi mdi-calculator-variant-outline" },
        { path: "/tat-system", label: "Dashboard theo dõi TAT trong lab", icon: "mdi mdi-calculator-variant-outline" },
      ],
    },
    { path: "/user-management", label: "Quản lý người dùng", icon: "mdi mdi-account" },
    { path: "/TargetPAKD", label: "Quản lý target PAKD", icon: "mdi mdi-bullseye" },
    { path: "/SystemAccessHistory", label: "Quản lý lịch sử truy cập", icon: "mdi mdi-history" },
    { path: "/KHCLRevenueReport", label: "Báo cáo doanh số nhóm KHCL", icon: "mdi mdi-chart-line" },
    { path: "/TestListDepartmentSite", label: "Danh sách xét nghiệm khoa phòng trên site", icon: "mdi mdi-flask-outline" },
  ];
  
  export default menuConfig;
  